const engagementTypes = ["engagement ring", "engagement_ring"]

function getFilteredProducts(products, filters) {
  let filteredProducts = [...products]

  const { colours, sort, price, types, styles } = filters

  if (colours && colours.length > 0) {
    filteredProducts = filteredProducts.filter((product) => {
      let isIncluded = false
      let engagement = product.product_type === "engagement_ring"

      if (!engagement) {
        if (product.options) {
          product.options.forEach((option) => {
            let optionValues = option.values
            let optionsData = []
            optionValues.forEach((optionValue) => {
              let splitValues = optionValue.split("&")
              splitValues.forEach((value) =>
                optionsData.push(value.toLowerCase().trim())
              )
            })

            colours.forEach((material) => {
              if (optionsData.includes(material.value) && !isIncluded) {
                isIncluded = true
              }
            })
          })
        }
      } else {
        if (product.colourOptions) {
          let colourOptions = product.colourOptions.map((option) => option.toLowerCase())
          colours.forEach((material) => {
            if (colourOptions.includes(material.value) && !isIncluded) {
              isIncluded = true
            }
          })
        }
      }

      if (isIncluded) {
        return product
      } else {
        return false
      }
    })
  }

  if (sort) {
    filteredProducts = sortBy(filteredProducts, sort.value)
  }

  if (price) {
    filteredProducts = filterByPrice(filteredProducts, price.value)
  }

  if (types) {
    filteredProducts = filterByTypes(filteredProducts, types)
  }

  if (styles) {
    filteredProducts = filterByStyles(filteredProducts, styles)
  }

  return filteredProducts
}

function filterByPrice(products, price) {
  const filteredProducts = products.filter(
    (product) =>
      parseFloat(product?.priceRangeV2?.minVariantPrice?.amount || product.startingPrice) <= price
  )

  return filteredProducts
}

function filterByTypes(products, types) {
  if (types.length === 0) {
    return products
  }
  let filteredProducts = []

  products.forEach((product) => {
    let isIncluded = false

    let productTags = []

    if (product.product_type !== "engagement_ring") {
      productTags = product.tags.map((tag) => tag.toLowerCase())
    } else {
      productTags.push("engraving")
      product.collectionUrls.forEach((url) => productTags.push(url.toLowerCase()))
      product.tags?.forEach((tag) => productTags.push(tag.toLowerCase().trim()))
    }

    isIncluded = types.every((type) =>
      productTags.find((tag) => tag.includes(type.value))
    )

    if (isIncluded) {
      filteredProducts.push(product)
    }
  })

  return filteredProducts
}

function filterByStyles(products, styles) {
  if (styles.length === 0) {
    return products
  }
  let filteredProducts = []

  products.forEach((product) => {
    let isIncluded = false

    let productTags = []

    if (product.product_type !== "engagement_ring") {
      productTags = product.tags.map((tag) => tag.toLowerCase())
    } else {
      product.tags?.forEach((tag) => productTags.push(tag.toLowerCase().trim()))
    }

    isIncluded = styles.every((style) =>
      productTags.find((tag) => tag.includes(style.value))
    )

    if (isIncluded) {
      filteredProducts.push(product)
    }
  })

  return filteredProducts
}

function filterByCategory(products, currentCategories) {
  if (currentCategories.length < 1) {
    return products
  }

  let filteredProducts = []

  if (currentCategories.length > 0) {
    let categoriesData = currentCategories
      .filter((category) => category !== "all")
      .map((category) => category.split(" ").join("-").toLowerCase())

    products.forEach((product) => {
      let includeProduct = false
      let isEngagement = engagementTypes.includes(
        product.product_type?.toLowerCase()
      )

      if (!isEngagement) {
        let tags = []
        product.tags.forEach((tag) => {
          const tagName = tag.toLowerCase()
          const tagNameAlternative = tagName + "s"

          tags.push(tagName, tagNameAlternative)
        })

        if (categoriesData.length === 0) {
          includeProduct = true
        }

        if (categoriesData.every((element) => tags.includes(element))) {
          includeProduct = true
        }
      } else {
        if (categoriesData.every((element) => element === "rings")) {
          includeProduct = true
        } else if (
          product.collectionUrls &&
          categoriesData.every((element) =>
            product.collectionUrls.includes(element)
          )
        ) {
          includeProduct = true
        }
      }

      if (includeProduct) {
        filteredProducts.push(product)
      }
    })
  }
  return filteredProducts
}

function filterByMaterial(products, currentMaterials) {
  if (currentMaterials.length < 1 || currentMaterials.includes("All Colors")) {
    return products
  }

  let filteredProducts = []

  if (currentMaterials.length > 0) {
    let materialsData = []

    currentMaterials.forEach((currentMaterial) => {
      materialsData.push(currentMaterial.toLowerCase())
    })

    products.forEach((product) => {
      let includeProduct = false
      let isEngagement = engagementTypes.includes(
        product.product_type?.toLowerCase()
      )

      if (isEngagement) {
        let colourOptions = product.colourOptions.map((option) =>
          option.toLowerCase()
        )
        materialsData.forEach((material) => {
          if (colourOptions.includes(material)) {
            includeProduct = true
            return false
          }
        })
      }

      if (!isEngagement && product.options.length > 0) {
        product.options.forEach((option) => {
          let optionValues = option.values
          let optionsData = []

          optionValues.forEach((optionValue) => {
            let splitValues = optionValue.split("&")
            splitValues.forEach((value) =>
              optionsData.push(value.toLowerCase().trim())
            )
          })

          materialsData.forEach((material) => {
            if (optionsData.includes(material)) {
              includeProduct = true

              return false
            }
          })
        })
      }

      if (includeProduct) {
        filteredProducts.push(product)
      }
    })
  }

  return filteredProducts
}

function sortBy(products, sortBy) {
  if (sortBy === "all") {
    return products
  }
  if (sortBy === "lowest") {
    return products.sort(ascending)
  }
  if (sortBy === "highest") {
    return products.sort(descending)
  }
  if (sortBy === "newest") {
    return products.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )
  }
  return products
}

function ascending(a, b) {
  const minPriceA =
    a.priceRangeV2?.minVariantPrice.amount * 1 || a.startingPrice
  const minPriceB =
    b.priceRangeV2?.minVariantPrice.amount * 1 || b.startingPrice

  if (minPriceA < minPriceB) {
    return -1
  }

  if (minPriceA > minPriceB) {
    return 1
  }

  return 0
}
function descending(a, b) {
  const minPriceA =
    a.priceRangeV2?.minVariantPrice.amount * 1 || a.startingPrice
  const minPriceB =
    b.priceRangeV2?.minVariantPrice.amount * 1 || b.startingPrice

  if (minPriceA > minPriceB) {
    return -1
  }

  if (minPriceA > minPriceB) {
    return 1
  }

  return 0
}

module.exports = {
  getFilteredProducts: getFilteredProducts,
  filterByCategory: filterByCategory,
  filterByMaterial: filterByMaterial,
  sortBy: sortBy,
}
